/*
  @author Austin Kang
  @description lib Authentication API
*/

import { getAuthServiceUrl } from "../../lib/utility";
import { apiFactory } from "../api/api";
import { LoginPayload } from "./type/loginPayload";
import { config } from "../../config";
import { setInLocalStorage } from "../utility";

const { post } = apiFactory(getAuthServiceUrl("api/login/"));

const postLoginWithPassword = async (payload: LoginPayload) => {
  try {
    const response = await post({}, payload);
    const data = await response.json();
    console.log("Login Response:", data); // Log the parsed response data

    const jwtToken = data.token;
    setInLocalStorage(config.jwtToken, jwtToken);
    return JSON.stringify({ jwtToken, refreshToken: data.refreshToken });
  } catch (error) {
    console.error("Error during login:", error);
    throw error;
  }
};

export { postLoginWithPassword };
